export const MONTH_REPORT_ID = 'month';
